/* /cart page: same behaviour as the cart drawer (shared helpers in Theme.cartUI), then re-renders this section after every cart change. */
(() => {
  const T = window.Theme || {};

  class CartPage extends HTMLElement {
    connectedCallback() {
      this.wait = () => this.refreshing;
      this.addEventListener('click', (e) => T.cartUI.onClick(this, e, this.wait));
      this.addEventListener('change', (e) => T.cartUI.onChange(this, e, this.wait));
      this.addEventListener('input', (e) => T.cartUI.onInput(e));
      this.addEventListener('keydown', (e) => T.cartUI.onKeydown(this, e, this.wait));
      this.onUpdated = () => { this.refreshing = this.refresh(); };
      document.addEventListener('cart:updated', this.onUpdated);
      this.paint();
      T.cartUI.syncCodes?.();
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onUpdated);
      this.io?.disconnect();
    }

    async refresh() {
      try {
        const id = this.dataset.sectionId;
        const sections = await T.fetchSections(location.pathname, [id]);
        const doc = new DOMParser().parseFromString(sections[id] || '', 'text/html');
        const fresh = doc.querySelector('[data-cart-page-inner]');
        const inner = this.querySelector('[data-cart-page-inner]');
        if (fresh && inner) {
          const restore = T.captureFocus(this);
          inner.replaceWith(fresh);
          T.revive(fresh);
          T.cartUI.restoreNote?.(fresh);
          restore();
        }
        this.paint();
        await T.cartUI.syncCodes?.();
        T.reveal?.(this);
        T.renderPromos?.(this);
      } catch (e) { location.reload(); }
    }

    paint() {
      T.cartUI.paint(this);
      this.sticky();
    }

    /* Mobile sticky checkout bar: shown only while the real checkout button is off screen. */
    sticky() {
      this.io?.disconnect();
      const bar = this.querySelector('[data-cart-sticky]');
      const target = this.querySelector('[data-cart-checkout]');
      if (!bar || !target || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting;
      });
      this.io.observe(target);
    }
  }
  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);
})();
